import { render, staticRenderFns } from "./pgvideo.vue?vue&type=template&id=710228f2&"
import script from "./pgvideo.vue?vue&type=script&lang=js&"
export * from "./pgvideo.vue?vue&type=script&lang=js&"
import style0 from "./pgvideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports